// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3438t","largestCol":"styles_largestCol__2H8Nt","smallestCol":"styles_smallestCol__3Qs_H"};